import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./analyticsService";
import * as Sentry from "@sentry/react";
import { uxCamTagScreen } from "../../utils/UXCam";

/**
 * This component is just a black hole into which all route changes fall.
 *
 * SCORZA-703: the tracking runs in an effect keyed on the pathname, not in the
 * render body. A render is not a page visit — this component re-renders
 * whenever the router context changes or a parent re-renders, and StrictMode
 * runs every render twice, each of which used to emit a duplicate page view.
 * Keyed on the pathname, one visit produces exactly one event.
 */
export function PageViewAnalytics() {
    const { pathname } = useLocation();

    useEffect(() => {
        trackPageView(pathname);
        Sentry.addBreadcrumb({
            category: "pageView",
            message: pathname,
        });

        // uxCamTagScreen no-ops when the native UXCam plugin isn't present.
        uxCamTagScreen(pathname);
    }, [pathname]);

    return null;
}
